(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var popup = document.getElementById('soan-cart-confirm');
    if (!popup) return;
    var autoCloseTimer = null;

    function updateCartBadge(count) {
      var cartIconBubble = document.getElementById('cart-icon-bubble');
      if (!cartIconBubble) return;
      var bubble = cartIconBubble.querySelector('.cart-count-bubble');
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        cartIconBubble.appendChild(bubble);
      }
      bubble.innerHTML = count < 100
        ? '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' article' + (count > 1 ? 's' : '') + '</span>'
        : '<span class="visually-hidden">' + count + ' articles</span>';
    }

    function showPopup(cartCount) {
      updateCartBadge(cartCount);
      popup.classList.add('soan-cart-confirm--visible');
      clearTimeout(autoCloseTimer);
      autoCloseTimer = setTimeout(function() {
        popup.classList.remove('soan-cart-confirm--visible');
      }, 1000);
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('form[data-type="add-to-cart-form"] [type="submit"]');
      if (!btn || btn.disabled) return;
      setTimeout(function() {
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            if (cart.items && cart.items.length) showPopup(cart.item_count);
          });
      }, 800);
    });
  });
})();
